module.exports = __webpack_public_path__ + "static/media/AvenirLTStd-Book.ecb0c2ae.otf";